/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import lowerCase from 'lodash/lowerCase';

// we get all sorts of junk from the LLM even though we tell it to:
//    "Ensure the label is in plain text, comprehensible, representative of the topic, and free from any punctuation or unnecessary formatting."

// this attempts to prettify labels:
export const formatKeyLabel = (str: string): string => {
  // if there are undesirable symbols use lodash on first pass, otherwise retain some desired capitals (eg NBN)
  const lowerCased = /[-_\.]/.test(str) ? lowerCase(str) : str;
  // then capitalise first chr.
  const titleCased = lowerCased.charAt(0).toUpperCase() + lowerCased.substring(1);
  return titleCased;
};
